import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Section from '../LandingSection';

import styles from './LandingSellingPointsSection.module.scss';

const noop = () => {};

const LandingSellingPointsSection = ({
  title,
  description,
  subtitle,
  renderSubtitleIcon = noop,
  points,
  color = 'interaction',
  pointTitleTag: PointTitle = 'h3'
}) => {
  return (
    <Section
      className={classNames(
        styles['selling-points__wrapper'],
        styles[`selling-points__wrapper--${color}`]
      )}
      containerClassName={styles['selling-points']}
    >
      <div className={styles['selling-points__title-container']}>
        <div className={styles['selling-points__subtitle']}>
          {renderSubtitleIcon()}
          {subtitle}
        </div>
        <h2 className={styles['selling-points__title']}>{title}</h2>
        <p>{description}</p>
      </div>
      <div className={styles['selling-points__points-container']}>
        {points.map(({ titleKey, textKey, renderImage }) => (
          <div className={styles['selling-points__point']} key={titleKey}>
            {renderImage(styles['selling-points__point__icon'])}
            <div>
              <PointTitle className={styles['selling-points__point__title']}>
                {trans(titleKey)}
              </PointTitle>
              <p className={styles['selling-points__point__text']}>
                {trans(textKey)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

LandingSellingPointsSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  renderSubtitleIcon: PropTypes.func,
  points: PropTypes.arrayOf(
    PropTypes.shape({
      titleKey: PropTypes.string.isRequired,
      textKey: PropTypes.string.isRequired,
      renderImage: PropTypes.func.isRequired
    })
  ).isRequired,
  color: PropTypes.oneOf(['interaction', 'secondary-pink-light', 'white']),
  pointTitleTag: PropTypes.elementType
};

export default LandingSellingPointsSection;
